<template>
  <div class="addAddress absolute">
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">卡号</div>
        <input
          type="text"
          placeholder="请输入卡号"
          v-model="userCard.number"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">密码</div>
        <input
          type="text"
          placeholder="请输入密码"
          v-model="userCard.password"
          required
        />
      </div>
    </div>
    <div></div>
    <div class="keepBnt bg-color-red" @click="submit">激活</div>
  </div>
</template>
<script type="text/babel">

import { postBlackCard } from "@api/user";
// import attrs, { required } from "@utils/validate";
// import { validatorDefaultCatch } from "@utils/dialog";
import attrs, { required, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { openAddress } from "@libs/wechat";
import { isWeixin } from "@utils";

export default {
  data() {
    return {
      show2: false,
      model2: "",
      id: 0,
      userCard: { is_default: 0 },
      address: {},
    };
  },
  mounted: function() {
    let id = this.$route.params.id;
    this.id = id;
    document.title = !id ? "激活黑卡" : "修改黑卡";
  },
  methods: {
    async submit() {
      let number = this.userCard.number,
        password = this.userCard.password;
      try {
        await this.$validator({
          number: [
            required(required.message("卡号")),
            attrs.range([1, 16], attrs.range.message("卡号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([1, 16], attrs.range.message("密码"))
          ],
        }).validate({ number, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      try {
        let that = this,
          data = {
            id: that.id,
            number: number,
            password: password,
          };
        postBlackCard(data).then(function(response) {
          console.log(response);
           that.$dialog.toast({ mes: "激活成功" });
          that.$router.push({path:'/user'})
        }).catch(function(e){
          console.log(e);
          that.$dialog.toast({ mes: "激活失败："+(e.data.msg) });
        });
      } catch (e) {
        this.$dialog.toast("激活失败:"+(e.data.msg));
      }
    },
    ChangeIsDefault: function() {
      this.userCard.is_default = !this.userCard.is_default;
    },
    result2(ret) {
    }
  }
};
</script>
